module.exports = __webpack_public_path__ + "static/media/Q2-1.edeac329.jpg";